import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateSelectedFeeSchedule } from '../../../../../services/ContractService/contractSlice';

const FeeScheduleEndDateEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const selectedFeeSchedule = useAppSelector((state) => state.contract.currentFeeSchedule);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (selectedFeeSchedule) {
      dispatch(updateSelectedFeeSchedule({
        ...selectedFeeSchedule,
        endDate: event.target.value || null
      }));
    }
  };

  // Convert ISO string to YYYY-MM-DD format for date input
  const getDateValue = () => {
    if (!selectedFeeSchedule?.endDate) return '';
    const date = new Date(selectedFeeSchedule.endDate);
    return date.toISOString().split('T')[0];
  };

  return (
    <TextField
      fullWidth
      label="End Date"
      type="date"
      value={getDateValue()}
      onChange={handleChange}
      size="small"
      variant="outlined"
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};

export default FeeScheduleEndDateEditor;
